var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCelebrating(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 289,
    height: 123,
    viewBox: "0 0 289 123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLAYipp_mail_-_Invite",
    "data-name": "PLAYipp mail - Invite",
    transform: "translate(-70 -110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9183",
    "data-name": "Group 9183",
    transform: "translate(133.815 110.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M302.96,705.664a11.233,11.233,0,0,0-4.1.076c-1.3.362-2.371,1.421-1.986,2.432.86,2.255,5.909.685,8.237,2.226.831.551,1.155,1.418,1.8,2.094a8.263,8.263,0,0,0,4.6,1.893c10.471,1.693,22.407-2.664,31.585,1.532,2.972,1.36,5.316,3.523,8.575,4.43,4.317,1.2,9.045-.082,13.512-.905a66.092,66.092,0,0,1,16.9-.886c4.177.322,9.733.43,11.07-2.6.86-1.951-.96-4.122-3.376-5.045s-5.245-.894-7.943-.805c-5.208.187-10.418.564-15.626.38-10.071-.358-19.585-4.349-29.392-4.481C325.4,705.862,314.434,706.82,302.96,705.664Z",
    transform: "translate(-264.637 -603.728)",
    fill: "#64ce81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    d: "M260.419,383.772a6.918,6.918,0,0,0-1.709,4.125,5.948,5.948,0,0,0,5.81-5.9A7,7,0,0,0,260.419,383.772Z",
    transform: "translate(-232.375 -331.691)",
    fill: "#60946e",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    d: "M308.743,120.2a6.968,6.968,0,0,0,2.655,3.592,5.942,5.942,0,0,0-2.059-8.017A6.916,6.916,0,0,0,308.743,120.2Z",
    transform: "translate(-274.35 -107.863)",
    fill: "#60946e",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    d: "M885.5,171.824a6.925,6.925,0,0,0-1.711,4.125,5.945,5.945,0,0,0,5.81-5.9A7.039,7.039,0,0,0,885.5,171.824Z",
    transform: "translate(-757.272 -153.399)",
    fill: "#60946e",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M589.537,301.985a6.975,6.975,0,0,0,1.332,4.262,5.942,5.942,0,0,0,.68-8.248A6.95,6.95,0,0,0,589.537,301.985Z",
    transform: "translate(-510.211 -261.101)",
    fill: "#60946e",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M917.6,500.287a6.975,6.975,0,0,0,1.332,4.262,5.944,5.944,0,0,0,.68-8.249A6.964,6.964,0,0,0,917.6,500.287Z",
    transform: "translate(-785.74 -427.768)",
    fill: "#60946e",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    d: "M189.347,82.028c-10.385-.31-20.276-3.183-29.721-6.335s-18.8-6.636-28.936-8.3c-6.52-1.073-13.976-1.224-19.228,1.776-5.056,2.886-6.69,7.869-7.567,12.493-.661,3.478-1.049,7.139.761,10.4,1.258,2.262,3.488,4.162,5.032,6.327,5.371,7.537,1.574,16.829-4.244,24.194-2.728,3.452-5.9,6.744-8,10.419s-3.081,7.884-1.237,11.63c1.826,3.715,6.179,6.505,10.9,8.468,9.578,3.979,20.86,5.127,31.87,5.773,24.363,1.433,48.855.812,73.282.191a249.777,249.777,0,0,0,27.012-1.662c4.939-.665,10.037-1.722,13.623-4.275,4.551-3.241,5.679-8.727,2.628-12.791-5.116-6.814-19.256-8.508-22.836-15.821-1.967-4.025.053-8.509,2.914-12.243,6.136-8.009,16.42-15.037,16.961-24.194.372-6.287-4.572-12.584-12.216-15.559-8.012-3.12-19.124-2.727-25.032,2.435C209.214,80.255,198.517,82.3,189.347,82.028Z",
    transform: "translate(-95.226 -66.687)",
    fill: "#64ce81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    d: "M425.124,130.477a1.445,1.445,0,0,0-.989.863l-.161-.026-.6-.1s-3.183-.26-3.777-.22a1.19,1.19,0,0,1-.967-.54l-2.366-1.982-.184-.159c.256-.1.416-.145.416-.145s-6.35-7.813-7.719-7.964-3.633-1.975-3.655-1.993l-.024-.124c-.05-.263-.087-.529-.114-.8l.337.2h0a2.667,2.667,0,0,1,.01-.277h0a5.012,5.012,0,0,1,.947-2.679c.662-.909,1.641-1.623,2.033-2.671a3.822,3.822,0,0,0,.208-1.4,4.634,4.634,0,0,0-.66-2.438,3.077,3.077,0,0,0-2.078-1.419c-.226-.035-.456-.04-.678-.091-1.323-.308-1.809-2.063-3.094-2.494a2.631,2.631,0,0,0-1.844.18c-.578.249-1.1.606-1.667.882a9.878,9.878,0,0,0-1.72.869,1.8,1.8,0,0,0-.161.137h0l-.1.1h0a3.616,3.616,0,0,0-.549.71l-.024.04c-.016.027-.031.056-.045.085s-.024.045-.034.067-.026.051-.037.077l-.034.077-.029.073c-.01.027-.021.054-.029.083s-.016.046-.023.07l-.024.085-.015.069a.56.56,0,0,1-.016.088.28.28,0,0,0,0,.064v.295a.96.96,0,0,0,.029.139h0a2.788,2.788,0,0,0,.615.855c-.026.024-.052.046-.077.072a5.53,5.53,0,0,0-1.719,4,5.427,5.427,0,0,0,.092.99,5.38,5.38,0,0,0-.939-.563,8.268,8.268,0,0,0-3.494-.8,24.286,24.286,0,0,1-4.746-.756,1.852,1.852,0,0,1,.161.423c-.121-.069-.251-.142-.395-.218a11.652,11.652,0,0,0-3.705-1.228s-.822.113-.931-1.594a7.175,7.175,0,0,0-.29-1.574,26.579,26.579,0,0,1-.976-4.783L379,100.535s1.24-6.537.495-9.324a1.92,1.92,0,0,0-.686-2.25c-3.12-2.274-6.268,6.575-6.268,6.575l-1.169,1.124a2.526,2.526,0,0,0-.992-.375,5.461,5.461,0,0,0-1.068,2.379c-.232.923-1.817,2.465-3.251,3.707-1.018.882-2,1.8-2.982,2.718-.725.682-2.341,1.658-5.865,2.21-.553.086-1.055.167-1.514.242a4.632,4.632,0,0,0,.177-1.266,4.76,4.76,0,0,0-3.763-4.613,1.177,1.177,0,0,0,0-.336,1.39,1.39,0,0,0-.356-.638,6.9,6.9,0,0,0-2.653-2.274,3.488,3.488,0,0,0-1.432-.228h-.393a3.681,3.681,0,0,0-2.684,1.384c-.4.525-.635,1.146-.976,1.706a7.636,7.636,0,0,1-2.669,2.467c-.636.381-1.3.71-1.906,1.142a7.036,7.036,0,0,0-2.637,7.054,10.723,10.723,0,0,1,.615,3.409,5.954,5.954,0,0,1-1.091,2.457,7.618,7.618,0,0,0-1.218,2.409,2.369,2.369,0,0,0,.754,2.446,5.95,5.95,0,0,1,.839.555,2.658,2.658,0,0,1,.387.6,6.019,6.019,0,0,0,3.749,2.883,2.765,2.765,0,0,0,.767.083h.077a1.3,1.3,0,0,0,1.4-.638,1.437,1.437,0,0,1,.134-.338.4.4,0,0,1,.234-.159,2.159,2.159,0,0,1,.546.2,7,7,0,0,0,2.655.751,3.774,3.774,0,0,0,.466.008,2.078,2.078,0,0,0,.949-.134,2.027,2.027,0,0,0,.73-.619c.042-.053.081-.108.121-.159a13.094,13.094,0,0,1-1.189,3.667,6.608,6.608,0,0,0-.9,3.2,3.189,3.189,0,0,0,.362,1.69s.027-.07.084-.18a13.553,13.553,0,0,0,1.782,2.443,17.081,17.081,0,0,1-.169,3.806,7.823,7.823,0,0,0,3.038,8.662l1.01,2.189-4.158.292c-.42-.057-5.857-.781-5.885.273-.027,1.1.822,11.762,3.641,11.04,2.627-.673,1.761-3.783,1.63-4.2l.093-.026-.1-.029,2.1-1.972a.914.914,0,0,0-.161-.684l.021-.011,5.078.225,1.194,2.567s2.025,3.048.383,5.614a25.914,25.914,0,0,0-3.613,9.01,9.929,9.929,0,0,1-2.246,4.589c-.952.319-4.6,1.738-3.146,3.886,1.669,2.459,7.088,7.138,9.279,6.977s1.313-1.738,1.313-1.738l-1.832-1.757a43.761,43.761,0,0,1-.192-4.839,1.128,1.128,0,0,0-.805-1.153,12.076,12.076,0,0,1,1.546-4.809c1.313-1.792,5.529-9.678,5.529-9.678s1.34-1.177,1.039-4.678c-.121-1.413-.188-2.653-.227-3.634l4.771.212s5.118-.509,1.641-5.936-10.865-10.746-10.865-10.746l-.066-3.359c.335.083.532.124.532.124s-.029-.121-.077-.338l.077.018a72.264,72.264,0,0,1-1.4-8.211l.3.137c3.175,3.637,5.316.563,5.316.563s6.706-9.33,6.049-8.9a.576.576,0,0,1-.441.027l.483-1.524s1.98-2.994-.894-4.678c-2.345-1.374-2.284,2.934-2.183,4.562l-.116-.1s-2.244,3.348-3.449,5.214-2.217.638-2.217.638l-1.522-1.7a5.91,5.91,0,0,0,.362-2.124,3.587,3.587,0,0,0-1.029-2.755,4.757,4.757,0,0,1-1.537-3.181,3.337,3.337,0,0,1,.3-1.311l7.911-4.145s1.669.026,3.913-3.4a58.8,58.8,0,0,1,4.791-6.255s-.047-.067-.127-.177c.081-.094.127-.145.127-.145s-.092-.132-.248-.336l1.219-1.392a17.688,17.688,0,0,0-.015,1.889l.632,2.113.354,11.762s-.383,1.116,2.081,2.247c2.084.957,5.387,2.551,6.35,3.021-.035.086-.056.132-.056.132l.287-.019.042.019h0c4.815-.427,4.651,4.33,4.651,4.33s.322,9.678-1.148,13.047a19.3,19.3,0,0,0-1.26,7.538s.146-.711.966.218c-.016.081-.034.169-.053.26-.47,2.333-1.45,7.294-1.632,9.307a32.31,32.31,0,0,1-1.068,5.421l-.483,8.9,3.078.148-.034.319a1,1,0,0,1-.522.776c-1.054.566-3.544,2.551-3.344,8.677l-.106.985a12.287,12.287,0,0,1-1.5,4.753c-.071.124-.134.244-.187.359a.292.292,0,0,1,.084-.171s-1.6.328-1.271,4.606.822,5.026,1.479,5.078,3.866.829,3.694-.748a28.323,28.323,0,0,1-.109-5.614c.213-.534,1.086-1.975.258-2.323h0a12.1,12.1,0,0,0,.346-3,19.551,19.551,0,0,1,2.763-3.449c1.152-.936,1.772-2.526,2.189-4.571.029-.134,3.394-2.353,2.9-4.2-.087-.319-.15-.6-.2-.856-.021-.113-.039-.22-.055-.319h.06l.685-4.064v3.957l.406.053-.015.319-.172,3.795a6.194,6.194,0,0,1-.483,2.149,20.828,20.828,0,0,0-1.7,9.566l-.039,3.645c-.116.022-1.788.413-1.471,4.544.322,4.276.82,5.026,1.477,5.078s3.866.829,3.7-.748a28.462,28.462,0,0,1-.11-5.614c.213-.534.6-1.947-.232-2.294a3.03,3.03,0,0,1,.345-1.376c.361-.607,1.566-3.495,2.473-5.716a20.279,20.279,0,0,0,1.522-7.068v-.081a6.568,6.568,0,0,1,.524-2.38,15.248,15.248,0,0,0,.876-2.616c.023-.107.04-.21.056-.319l.786.1,2.684-11.5s.734-6.231.375-9.045c-.014-.116-.031-.223-.05-.327l.161.014s.548-1.389.383-7.325,1.1-7.813,1.1-7.813c.68-2.133,1.43-2.848,1.869-3.087h0a.8.8,0,0,1,.375-.121l2.031,2.3h0l.374.424a.128.128,0,0,0,0-.026l.161.187a1.7,1.7,0,0,1-.013-.285c1.084.623,3.589,2.081,5.084,3.127a4.668,4.668,0,0,0,4.188,1.062,11.537,11.537,0,0,0,3.37-1.1l.085-.04a4.14,4.14,0,0,0,.793.319s2.751,2.307,3.017-1.9S425.124,130.477,425.124,130.477Zm-71.362,49.037a4,4,0,0,1-.805-.336Zm-4.307-45.581.01.6-.042.019C349.435,134.341,349.445,134.133,349.455,133.934ZM392.488,187.3v.233A.169.169,0,0,1,392.488,187.3Z",
    transform: "translate(-296.431 -85.059)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4887",
    "data-name": "Rectangle 4887",
    width: 4.672,
    height: 4.913,
    transform: "translate(100.12 32.173)",
    fill: "#3b7fa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M634.908,583.293c-.411,2.054-1.02,3.65-2.147,4.591a19.74,19.74,0,0,0-2.711,3.463c-.027,3.355-.913,4.375-.913,4.375l-.913.242h-2.255a11.163,11.163,0,0,1-.483-1.8,2.11,2.11,0,0,1,.354-1,12.551,12.551,0,0,0,1.474-4.773l.1-.991c-.19-6.149,2.255-8.145,3.281-8.713a1.006,1.006,0,0,0,.511-.78h0l.182-1.757,6.067.3a4.812,4.812,0,0,0,.1,1.772c.047.256.11.541.193.859C638.236,580.93,634.934,583.157,634.908,583.293Z",
    transform: "translate(-540.421 -494.97)",
    fill: "#8e5362"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M701.247,582.268a15.643,15.643,0,0,1-.859,2.627,6.748,6.748,0,0,0-.516,2.391v.082a20.807,20.807,0,0,1-1.493,7.1c-.891,2.229-2.072,5.131-2.426,5.741a4.743,4.743,0,0,0-.242,2.739L692.3,602.7l.06-5.746a21.394,21.394,0,0,1,1.666-9.606,6.3,6.3,0,0,0,.483-2.157l.161-3.811.05-1.128s6.038-.859,6.547.511A2.9,2.9,0,0,1,701.247,582.268Z",
    transform: "translate(-596.51 -498.425)",
    fill: "#8e5362"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M667.357,578.22,661,577.908l.182-1.758,6.073.3A4.671,4.671,0,0,0,667.357,578.22Z",
    transform: "translate(-570.228 -494.84)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M713.582,582.268,707,581.384l.05-1.128s6.038-.859,6.547.511A2.877,2.877,0,0,1,713.582,582.268Z",
    transform: "translate(-608.849 -498.068)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "M662.922,443.861l-2.63,11.545-7.785-1.047v-3.974l-.673,4.084-9.343-.457.483-8.94a33.163,33.163,0,0,0,1.047-5.45c.182-2.02,1.139-7,1.6-9.343.161-.772.251-1.258.251-1.258s16,3.328,17.049,4.536a2.547,2.547,0,0,1,.369,1.226C663.643,437.6,662.922,443.861,662.922,443.861Z",
    transform: "translate(-554.724 -371.327)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M653.33,511.751s6.3-3.3,7.834-2.6Z",
    transform: "translate(-563.792 -438.452)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    d: "M674.66,458.82s5.235,3.974,5.4,5.047Z",
    transform: "translate(-581.694 -396.25)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    d: "M665.83,543.768s3.786-.161,4.994.805Z",
    transform: "translate(-574.28 -467.61)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    d: "M705.224,517.44s1.8,5.889,1.02,7.5-1.583-.377-1.583-.377Z",
    transform: "translate(-606.872 -445.535)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M684.716,708s-1.772.269-1.45,4.564.805,5.049,1.45,5.1,3.786.833,3.624-.752a29.32,29.32,0,0,1-.108-5.638c.214-.538.585-1.954-.227-2.3l-.176.828s-1.719-1.585-2.738-.43a4.466,4.466,0,0,0-.211-.826C684.779,708.292,684.556,708.161,684.716,708Z",
    transform: "translate(-588.886 -605.814)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M821.281,344.227s-.406.227-1,.511a11.16,11.16,0,0,1-3.305,1.1,4.5,4.5,0,0,1-4.108-1.066c-1.467-1.05-3.924-2.515-4.994-3.14l-.465-.275-.047-.027v-.019l.888-2.439,3.141-1.671.78.669,2.321,1.989a1.159,1.159,0,0,0,.947.543c.585-.04,3.705.221,3.705.221l.59.1,1.242.206Z",
    transform: "translate(-693.13 -294.05)",
    fill: "#8e5362"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    d: "M882.427,362.574s-.406.227-1,.511c-.63-.322-1.413-.926-1.111-1.92.272-.894.346-1.592.57-2.094l1.242.206Z",
    transform: "translate(-754.286 -312.413)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    "data-name": "Path 2396",
    d: "M882.842,353.274s3.5-1.007,3.243,3.222-2.961,1.914-2.961,1.914-2.3-.6-1.812-2.2S881.655,353.658,882.842,353.274Z",
    transform: "translate(-755.132 -307.461)",
    fill: "#8e5362"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2397",
    "data-name": "Path 2397",
    d: "M596.77,128.339l-3.65,1.534-.056.024-.04-.019-.227-.114c-.944-.47-4.188-2.08-6.229-3.035-2.416-1.128-2.041-2.255-2.041-2.255l-.348-11.813-.619-2.122s-.437-7.191,3.061-8.994,1.236,10.416,1.236,10.416l.271,2.539a27.191,27.191,0,0,0,.959,4.8,7.451,7.451,0,0,1,.283,1.58c.108,1.717.913,1.6.913,1.6a11.213,11.213,0,0,1,3.631,1.234,9.076,9.076,0,0,1,1.2.76Z",
    transform: "translate(-505.212 -95.777)",
    fill: "#8e5362"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    d: "M730.105,261.312l-3.115-.322a11.972,11.972,0,0,0,1.323-2.7,4.565,4.565,0,0,0,.137-.556,1.854,1.854,0,0,0-.171-1.368c-.912-1.342,5.424-3.222,5.424-3.222a15.462,15.462,0,0,0-.069,2.236,11.31,11.31,0,0,0,.161,1.548,3.84,3.84,0,0,0,1.3,2.526C737.085,260.829,730.105,261.312,730.105,261.312Z",
    transform: "translate(-625.636 -223.405)",
    fill: "#8e5362"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    d: "M730.105,281.018l-3.115-.322a11.972,11.972,0,0,0,1.323-2.7,1.125,1.125,0,0,0,.988.6s3.144.466,4.5-1.962a3.84,3.84,0,0,0,1.3,2.526C737.085,280.535,730.105,281.018,730.105,281.018Z",
    transform: "translate(-625.636 -243.138)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2400",
    "data-name": "Path 2400",
    d: "M807.921,341.632a1.725,1.725,0,0,0,.013.287l-.483-.562-.04-.047.888-2.439,3.141-1.671.78.669C811.1,338.3,807.971,339.65,807.921,341.632Z",
    transform: "translate(-693.144 -294.035)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2401",
    "data-name": "Path 2401",
    d: "M644.679,244.7l-3.65,1.534h-.1l-.282.019s.021-.047.055-.134c.3-.739,1.717-4.349,1.107-6.05a9.072,9.072,0,0,1,1.2.76Z",
    transform: "translate(-553.138 -212.407)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2402",
    "data-name": "Path 2402",
    d: "M679.6,434.769c-1.421-.127-15.635-1.442-16.961-3.534a7.345,7.345,0,0,0-.709-.966c.161-.772.251-1.258.251-1.258s16,3.328,17.05,4.536A2.514,2.514,0,0,1,679.6,434.769Z",
    transform: "translate(-571.038 -371.2)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    d: "M658.555,247.036s3.178.47,4.522-2c0,0,2.244,1.843,3.586,2s7.571,8,7.571,8-4.994,1.611-4.672,4.188l-2.363-2.738s-1.181-.055-2.2,3.222c0,0-1.236,1.878-1.074,7.839s-.375,7.357-.375,7.357-15.68-1.342-17.075-3.544-1.611-1.128-1.611-1.128a19.634,19.634,0,0,1,1.234-7.571c1.45-3.383,1.128-13.1,1.128-13.1s.161-4.779-4.564-4.349c0,0,1.986-4.618,1.074-6.39a23.258,23.258,0,0,0,4.654.76,7.961,7.961,0,0,1,3.428.805,3.8,3.8,0,0,1,1.422,1.073,2.089,2.089,0,0,0,2.416.7,24.384,24.384,0,0,0,1.4,3.436c.063.118.126.234.19.345a5.293,5.293,0,0,0,.287.454A1.152,1.152,0,0,0,658.555,247.036Z",
    transform: "translate(-554.899 -211.447)",
    fill: "#4b9fcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    d: "M739.9,255.356a5.522,5.522,0,0,1-.57.685,5.62,5.62,0,0,1-4.027,1.7,5.792,5.792,0,0,1-.582-.029,1.854,1.854,0,0,0-.171-1.368c-.912-1.342,5.424-3.222,5.424-3.222A15.489,15.489,0,0,0,739.9,255.356Z",
    transform: "translate(-631.902 -223.371)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    d: "M715.936,216.458a5.617,5.617,0,1,1-1.645-3.993A5.638,5.638,0,0,1,715.936,216.458Z",
    transform: "translate(-606.896 -187.834)",
    fill: "#8e5362"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M792,325.786l.116,3.773s1.683-1.356,1.737-2.645S792,325.786,792,325.786Z",
    transform: "translate(-680.198 -284.434)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M707.66,349.24s4.43,6.081,7.007,6.7S708.627,351.212,707.66,349.24Z",
    transform: "translate(-609.405 -304.161)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    d: "M736.83,353.17s2.469,2.79,4.241,3.138Z",
    transform: "translate(-633.887 -307.451)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    d: "M682.83,396.82s4.51,4.43,7.088,4.7Z",
    transform: "translate(-588.558 -344.142)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    d: "M724.661,216.454a5.617,5.617,0,0,1-1.611,3.94l-.619-.385a1.711,1.711,0,0,1-.6-.524,2.081,2.081,0,0,1-.129-1.168,2.748,2.748,0,0,0-.857-2.281c-1.068-.855-2.78-.382-3.866-1.221a3.809,3.809,0,0,1-.685-.762l-1.018-1.364c-.061-.081-.135-.161-.214-.256a5.638,5.638,0,0,1,9.591,4.027Z",
    transform: "translate(-615.623 -187.826)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "M712.717,190.4a10.116,10.116,0,0,1,1.687-.871c.567-.284,1.068-.644,1.635-.886a2.575,2.575,0,0,1,1.811-.182c1.261.433,1.738,2.2,3.035,2.5.219.052.445.056.665.09a3.029,3.029,0,0,1,2.038,1.426,4.746,4.746,0,0,1,.644,2.45,3.926,3.926,0,0,1-.2,1.406c-.383,1.052-1.345,1.772-1.994,2.682A5.1,5.1,0,0,0,721.1,202l-1.572-.978a1.7,1.7,0,0,1-.6-.524,2.082,2.082,0,0,1-.129-1.168,2.751,2.751,0,0,0-.855-2.281c-1.07-.855-2.782-.382-3.866-1.221a3.812,3.812,0,0,1-.685-.762l-1.018-1.364a3.887,3.887,0,0,1-.741-1.026A2.646,2.646,0,0,1,712.717,190.4Z",
    transform: "translate(-612.721 -168.964)",
    fill: "#362133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    d: "M719.688,212.177a1.7,1.7,0,0,1-.6-.524,2.081,2.081,0,0,1-.129-1.168,2.748,2.748,0,0,0-.857-2.281c-1.068-.855-2.78-.382-3.866-1.221a3.812,3.812,0,0,1-.685-.762l-1.018-1.364a3.849,3.849,0,0,1-.741-1.026,2.37,2.37,0,0,1,.744-1.951,2.517,2.517,0,0,0-.92,2.126,4.039,4.039,0,0,0,.741,1.026l1.018,1.364a3.811,3.811,0,0,0,.685.762c1.081.839,2.793.366,3.866,1.221a2.751,2.751,0,0,1,.855,2.281,2.082,2.082,0,0,0,.129,1.168,1.7,1.7,0,0,0,.6.524l1.572.978a2.658,2.658,0,0,1,.01-.279Z",
    transform: "translate(-612.697 -180.32)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    d: "M620.35,682.94s-1.569.322-1.247,4.625.805,5.049,1.45,5.1,3.786.833,3.624-.752a29.319,29.319,0,0,1-.108-5.638c.214-.538,1.065-1.983.253-2.333l-.656.857s-1.719-1.585-2.738-.43C620.928,684.37,619.974,683.315,620.35,682.94Z",
    transform: "translate(-535.015 -584.791)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    d: "M633.23,699.5c.34.161.657.358,1,.519a2.235,2.235,0,0,0,1.081.255.754.754,0,0,0,.441-.153",
    transform: "translate(-546.905 -598.683)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    d: "M697.33,725.62a5.472,5.472,0,0,0,.585.575,2.041,2.041,0,0,0,1.128.234.457.457,0,0,0,.193-.024.469.469,0,0,0,.172-.161l.211-.272",
    transform: "translate(-600.719 -620.596)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    d: "M532.565,253.776s-.725-6.872,2.094-5.181.878,4.7.878,4.7l-.662,2.122Z",
    transform: "translate(-462.324 -219.349)",
    fill: "#ffc1c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    d: "M561,101.234l1.611-1.582s3.088-8.887,6.149-6.6-3.879,8.054-3.879,8.054l-1.84,2.147Z",
    transform: "translate(-486.276 -88.487)",
    fill: "#ffc1c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    d: "M414.241,359.52l-.081,1.825s1.477,2.577,2.094,2.766.564-5.451.564-5.451Z",
    transform: "translate(-362.986 -312.074)",
    fill: "#64ce81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    d: "M414.241,359.52l-.081,1.825s1.477,2.577,2.094,2.766.564-5.451.564-5.451Z",
    transform: "translate(-362.986 -312.074)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "M334.76,284.87l.11,6.727h7.489l-.564-3.919Z",
    transform: "translate(-281.053 -239.421)",
    fill: "#ffc1c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M436.5,455.82l.35,2.147,4.377,9.72s1.986,3.061.375,5.638a26.389,26.389,0,0,0-3.544,9.047,10.524,10.524,0,0,1-2.389,4.833l4.618,1.96s.322-3.839,1.611-5.638,5.422-9.718,5.422-9.718,1.316-1.182,1.021-4.7-.269-5.988-.269-5.988l-.456-5.611Z",
    transform: "translate(-381.059 -393.916)",
    fill: "#ef8e57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M436.5,455.82l.35,2.147,4.377,9.72s1.986,3.061.375,5.638a26.389,26.389,0,0,0-3.544,9.047,10.524,10.524,0,0,1-2.389,4.833l4.618,1.96s.322-3.839,1.611-5.638,5.422-9.718,5.422-9.718,1.316-1.182,1.021-4.7-.269-5.988-.269-5.988l-.456-5.611Z",
    transform: "translate(-381.059 -393.916)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M419.229,648.82s-4.941,1.5-3.3,3.974,6.954,7.168,9.1,7.007,1.289-1.746,1.289-1.746l-1.8-1.772a43.164,43.164,0,0,1-.187-4.858c.135-1.1-1.53-1.611-1.746-.966S419.229,648.82,419.229,648.82Z",
    transform: "translate(-364.2 -555.981)",
    fill: "#883a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M427.012,375.58l-3.916.433a1.4,1.4,0,0,0-1.25,1.432,22.1,22.1,0,0,1-.15,4.51,7.957,7.957,0,0,0,2.98,8.7l5.827,1.853-9.343.672.3,5.182,1.45-.805,17.72.805s5.021-.511,1.611-5.96-10.658-10.793-10.658-10.793l-.081-4.243-.538-1.234Z",
    transform: "translate(-368.892 -326.375)",
    fill: "#ef8e57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M487.66,477.961a5.032,5.032,0,0,1,4.027,0Z",
    transform: "translate(-424.695 -411.96)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M393.8,483.083s-5.772-.831-5.8.269.805,11.813,3.571,11.088,1.583-4.269,1.583-4.269l2.068-1.986s.214-1.1-1.155-.994Z",
    transform: "translate(-341.026 -416.426)",
    fill: "#883a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M477.458,281.095l2.281,2.6s.994,1.236,2.175-.644,3.383-5.235,3.383-5.235,2.444,2.147,3.088,1.719-5.933,8.942-5.933,8.942-2.094,3.086-5.21-.564l-.912-.43Z",
    transform: "translate(-415.196 -244.151)",
    fill: "#64ce81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M477.458,281.095l2.281,2.6s.994,1.236,2.175-.644,3.383-5.235,3.383-5.235,2.444,2.147,3.088,1.719-5.933,8.942-5.933,8.942-2.094,3.086-5.21-.564l-.912-.43Z",
    transform: "translate(-415.196 -244.151)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1595",
    "data-name": "Ellipse 1595",
    cx: 4.752,
    cy: 4.752,
    r: 4.752,
    transform: "translate(50.58 17.197)",
    fill: "#ffc1c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    d: "M416.44,154.92s-4.084,1.933-3.6,5.316a74.8,74.8,0,0,1,.564,7.652s1.854,2.738-.6,7.974c0,0-1.571,2.658-.523,4.591,0,0,1.161-3.061,4.164-.805s7.837,3.3,7.837,3.3-2.5-10.954-.967-12.484c0,0,2.658-3.947.242-6.444s-1.208-4.833-1.208-4.833l7.76-4.161s1.637.026,3.839-3.41a59.17,59.17,0,0,1,4.7-6.282s-1.666-2.5-3.222-2.685a5.557,5.557,0,0,0-1.047,2.391c-.229.926-1.783,2.474-3.19,3.723-1,.886-1.962,1.806-2.924,2.738-.712.685-2.3,1.664-5.754,2.218C416.815,154.627,416.44,154.92,416.44,154.92Z",
    transform: "translate(-361.137 -130.413)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    d: "M416.44,152.92s-4.084,1.933-3.6,5.316a74.8,74.8,0,0,1,.564,7.652s1.854,2.739-.6,7.974c0,0-1.571,2.658-.523,4.591,0,0,1.161-3.061,4.164-.805s7.837,3.3,7.837,3.3-2.5-10.954-.967-12.484c0,0,2.658-3.947.242-6.444s-1.208-4.833-1.208-4.833l7.76-4.161s1.637.026,3.839-3.41a59.16,59.16,0,0,1,4.7-6.282s-1.666-2.5-3.222-2.685a5.557,5.557,0,0,0-1.047,2.391c-.229.926-1.783,2.474-3.19,3.723-1,.886-1.962,1.806-2.924,2.738-.712.685-2.3,1.664-5.754,2.218C416.815,152.627,416.44,152.92,416.44,152.92Z",
    transform: "translate(-361.137 -128.735)",
    fill: "#64ce81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    d: "M461.83,342.49s3.167,4.672,3.248,5.477C465.079,347.967,464.6,342.946,461.83,342.49Z",
    transform: "translate(-403.008 -298.484)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    d: "M436,244.82a3.9,3.9,0,0,0,5.4.43A6.845,6.845,0,0,1,436,244.82Z",
    transform: "translate(-381.325 -216.388)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    d: "M359.041,155.652a1.425,1.425,0,0,0-.348-.644,6.824,6.824,0,0,0-2.6-2.284,3.6,3.6,0,0,0-4.106,1.169c-.39.525-.622,1.15-.958,1.712a7.6,7.6,0,0,1-2.618,2.478c-.623.382-1.281.712-1.869,1.145a7.157,7.157,0,0,0-2.587,7.088,10.965,10.965,0,0,1,.6,3.423,6.062,6.062,0,0,1-1.068,2.468,7.8,7.8,0,0,0-1.2,2.416,2.411,2.411,0,0,0,.739,2.455,6.143,6.143,0,0,1,.823.557,2.673,2.673,0,0,1,.379.6,5.923,5.923,0,0,0,3.678,2.9c.693.182,1.622.116,1.875-.554a1.45,1.45,0,0,1,.13-.34c.229-.322.733-.142,1.087.043a6.732,6.732,0,0,0,2.6.746,2.167,2.167,0,0,0,1.065-.127,1.967,1.967,0,0,0,.717-.62,7.64,7.64,0,0,0,1.236-3.929,9.179,9.179,0,0,0-.011-2.706c-.274-1.427-1.142-2.761-1.013-4.208.137-1.546,1.392-2.811,1.583-4.349a3.316,3.316,0,0,0-.565-2.286,3.266,3.266,0,0,1-.43-.673.668.668,0,0,1,.129-.739,1.127,1.127,0,0,1,.335-.161,2.786,2.786,0,0,0,1.662-2.5,5.548,5.548,0,0,1,.111-1.166C358.6,156.963,359.133,156.3,359.041,155.652Z",
    transform: "translate(-302.606 -138.673)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M357.041,155.652a1.425,1.425,0,0,0-.348-.644,6.824,6.824,0,0,0-2.6-2.284,3.6,3.6,0,0,0-4.106,1.169c-.39.525-.622,1.15-.958,1.712a7.6,7.6,0,0,1-2.618,2.478c-.623.382-1.281.712-1.869,1.145a7.157,7.157,0,0,0-2.587,7.088,10.964,10.964,0,0,1,.6,3.423,6.061,6.061,0,0,1-1.068,2.468,7.8,7.8,0,0,0-1.2,2.416,2.411,2.411,0,0,0,.739,2.455,6.141,6.141,0,0,1,.823.557,2.673,2.673,0,0,1,.379.6,5.923,5.923,0,0,0,3.678,2.9c.693.182,1.622.116,1.875-.554a1.45,1.45,0,0,1,.13-.34c.229-.322.733-.142,1.087.044a6.732,6.732,0,0,0,2.6.746,2.167,2.167,0,0,0,1.065-.127,1.967,1.967,0,0,0,.717-.62,7.64,7.64,0,0,0,1.236-3.929,9.179,9.179,0,0,0-.011-2.706c-.274-1.427-1.142-2.761-1.013-4.208.137-1.546,1.392-2.811,1.583-4.349a3.317,3.317,0,0,0-.565-2.286,3.265,3.265,0,0,1-.43-.673.669.669,0,0,1,.129-.739,1.128,1.128,0,0,1,.335-.161,2.786,2.786,0,0,0,1.662-2.5,5.548,5.548,0,0,1,.111-1.166C356.6,156.963,357.133,156.3,357.041,155.652Z",
    transform: "translate(-300.927 -138.673)",
    fill: "#bb7684"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9182",
    "data-name": "Group 9182",
    transform: "translate(45.38 13.817)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M379.22,323.769a1.518,1.518,0,0,0-.132.34,1.078,1.078,0,0,1-.978.628,1.311,1.311,0,0,0,1.461-.628,1.517,1.517,0,0,1,.132-.34.4.4,0,0,1,.161-.137A.553.553,0,0,0,379.22,323.769Z",
    transform: "translate(-378.11 -296.024)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M416.644,155.622a1.39,1.39,0,0,0-.348-.644,6.823,6.823,0,0,0-2.6-2.284,3.383,3.383,0,0,0-1.482-.222,3.29,3.29,0,0,1,1,.222,6.823,6.823,0,0,1,2.6,2.284,1.39,1.39,0,0,1,.348.644c.092.644-.443,1.313-.62,1.909a5.053,5.053,0,0,0-.111,1.166,2.8,2.8,0,0,1-1.664,2.5,1.127,1.127,0,0,0-.335.161.668.668,0,0,0-.127.741,3.259,3.259,0,0,0,.428.673,3.314,3.314,0,0,1,.567,2.284c-.193,1.542-1.45,2.8-1.585,4.349-.129,1.45.741,2.78,1.013,4.206a9.233,9.233,0,0,1,.011,2.706,7.619,7.619,0,0,1-1.236,3.929,1.961,1.961,0,0,1-.715.62,1.6,1.6,0,0,1-.527.13,2.083,2.083,0,0,0,1.01-.13,1.96,1.96,0,0,0,.72-.609,7.62,7.62,0,0,0,1.236-3.929,9.179,9.179,0,0,0-.011-2.706c-.272-1.426-1.142-2.761-1.013-4.206.139-1.548,1.392-2.811,1.585-4.349a3.314,3.314,0,0,0-.567-2.284,3.262,3.262,0,0,1-.428-.673.669.669,0,0,1,.127-.741,1.128,1.128,0,0,1,.335-.161,2.791,2.791,0,0,0,1.664-2.5,5.435,5.435,0,0,1,.111-1.166C416.2,156.935,416.735,156.271,416.644,155.622Z",
    transform: "translate(-405.92 -152.462)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M406.82,525a2.176,2.176,0,0,0,2.228.615",
    transform: "translate(-356.823 -451.846)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    d: "M465.112,696a1.367,1.367,0,0,1-1.112.28",
    transform: "translate(-404.827 -595.747)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1596",
    "data-name": "Ellipse 1596",
    cx: 4.338,
    cy: 0.733,
    rx: 4.338,
    ry: 0.733,
    transform: "translate(12.601 103.787)",
    fill: "#64ce81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1597",
    "data-name": "Ellipse 1597",
    cx: 4.338,
    cy: 0.733,
    rx: 4.338,
    ry: 0.733,
    transform: "translate(130.738 118.382)",
    fill: "#64ce81"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1598",
    "data-name": "Ellipse 1598",
    cx: 4.338,
    cy: 0.733,
    rx: 4.338,
    ry: 0.733,
    transform: "translate(130.738 104.274)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1599",
    "data-name": "Ellipse 1599",
    cx: 4.338,
    cy: 0.733,
    rx: 4.338,
    ry: 0.733,
    transform: "translate(24.8 110.593)",
    fill: "#64ce81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1600",
    "data-name": "Ellipse 1600",
    cx: 6.477,
    cy: 1.095,
    rx: 6.477,
    ry: 1.095,
    transform: "translate(142.318 110.231)",
    fill: "#64ce81"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1601",
    "data-name": "Ellipse 1601",
    cx: 14.62,
    cy: 2.471,
    rx: 14.62,
    ry: 2.471,
    transform: "translate(41.477 117.43)",
    fill: "#64ce81",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M1008.256,738.075a1.89,1.89,0,0,0,.619-.933.83.83,0,0,0-.432-.949,1.21,1.21,0,0,0-1.141.4,1.523,1.523,0,0,1-1.11.535,1.686,1.686,0,0,0,.522-1.58.662.662,0,0,0-.145-.322c-.221-.235-.619-.134-.883.052a3.288,3.288,0,0,0-1.076,2.751,5.171,5.171,0,0,1-.015-1.128,1.165,1.165,0,0,0-.425-1,1.3,1.3,0,0,0-.644-.161,1.347,1.347,0,0,0-1.054.3,1.036,1.036,0,0,0,.042,1.289,4.21,4.21,0,0,0,1.089.873,2.416,2.416,0,0,1,.78.743.813.813,0,0,1,.058.132h2.36A6.56,6.56,0,0,0,1008.256,738.075Z",
    transform: "translate(-856.783 -628.54)",
    fill: "#64ce81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    d: "M923.087,786.665a1.886,1.886,0,0,0,.617-.933.833.833,0,0,0-.432-.949,1.21,1.21,0,0,0-1.141.4,1.523,1.523,0,0,1-1.11.535,1.687,1.687,0,0,0,.522-1.58.645.645,0,0,0-.145-.322c-.219-.235-.619-.134-.881.052a3.288,3.288,0,0,0-1.076,2.751,5.078,5.078,0,0,1-.016-1.128,1.165,1.165,0,0,0-.425-1,1.288,1.288,0,0,0-.644-.153,1.347,1.347,0,0,0-1.054.3,1.036,1.036,0,0,0,.042,1.289,4.191,4.191,0,0,0,1.091.873,2.416,2.416,0,0,1,.778.743.819.819,0,0,1,.058.132h2.36A6.6,6.6,0,0,0,923.087,786.665Z",
    transform: "translate(-785.332 -669.303)",
    fill: "#64ce81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    "data-name": "Path 2441",
    d: "M302.6,584.225s-2.263-7.686.425-13.341a12.14,12.14,0,0,0,.986-7.62,20.389,20.389,0,0,0-1.078-3.575",
    transform: "translate(-268.579 -481.174)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    "data-name": "Path 2442",
    d: "M301.9,528.343c0,.942-1.706,3.673-1.706,3.673s-1.7-2.73-1.7-3.673a1.706,1.706,0,1,1,3.41,0Z",
    transform: "translate(-265.872 -453.205)",
    fill: "#64ce81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2443",
    "data-name": "Path 2443",
    d: "M319.308,556.382c-.512.789-3.428,2.155-3.428,2.155s.053-3.222.565-4.01a1.706,1.706,0,0,1,2.863,1.854Z",
    transform: "translate(-280.476 -476.064)",
    fill: "#64ce81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2444",
    "data-name": "Path 2444",
    d: "M315.318,608.532c-.841.425-4.048.132-4.048.132s1.671-2.753,2.511-3.177a1.706,1.706,0,0,1,1.537,3.045Z",
    transform: "translate(-276.607 -519.368)",
    fill: "#64ce81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2445",
    "data-name": "Path 2445",
    d: "M305.728,651.177c-.757.559-3.968.805-3.968.805s1.182-3,1.933-3.557a1.706,1.706,0,0,1,2.028,2.739Z",
    transform: "translate(-268.622 -555.352)",
    fill: "#64ce81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2446",
    "data-name": "Path 2446",
    d: "M291.1,569.312c.677.656,3.823,1.335,3.823,1.335s-.77-3.127-1.45-3.782a1.706,1.706,0,0,0-2.376,2.447Z",
    transform: "translate(-259.26 -486.671)",
    fill: "#64ce81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2447",
    "data-name": "Path 2447",
    d: "M277.681,616.563c.841.424,4.047.131,4.047.131s-1.671-2.753-2.511-3.177a1.706,1.706,0,1,0-1.535,3.046Z",
    transform: "translate(-247.619 -526.098)",
    fill: "#64ce81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2448",
    "data-name": "Path 2448",
    d: "M275.1,666.636c.757.561,3.968.805,3.968.805s-1.182-3-1.933-3.555a1.706,1.706,0,0,0-2.028,2.739Z",
    transform: "translate(-245.722 -568.346)",
    fill: "#64ce81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    d: "M274,695s2.756-.548,3.492-1.277,4.042-2.005,4.409-1.094,4.962,4.013,1.838,4.56-7.35.73-8.269.366S274,695,274,695Z",
    transform: "translate(-245.321 -592.656)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    d: "M283.744,710.72c-3.124.548-7.35.73-8.269.364-.7-.277-1.187-1.611-1.379-2.234l-.1.024s.551,2.189,1.471,2.555,5.145.182,8.269-.366c.9-.161,1.16-.528,1.063-1C284.73,710.366,284.416,710.6,283.744,710.72Z",
    transform: "translate(-245.321 -606.527)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    d: "M930.483,659.91s.886,1.158-.408,2.9-2.36,3.222-1.933,4.312c0,0,1.952-3.246,3.544-3.291S932.227,661.858,930.483,659.91Z",
    transform: "translate(-794.519 -565.271)",
    fill: "#64ce81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M930.754,659.91a1.449,1.449,0,0,1,.182.364c1.55,1.82,2.375,3.52.884,3.562-1.387.04-3.051,2.521-3.451,3.148a1.5,1.5,0,0,0,.047.143s1.952-3.246,3.544-3.291S932.5,661.858,930.754,659.91Z",
    transform: "translate(-794.791 -565.271)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M952.325,667.7c0,.408-.047.738-.1.738s-.1-.322-.1-.738.056-.216.113-.216S952.325,667.288,952.325,667.7Z",
    transform: "translate(-814.715 -571.546)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M953.257,670.64c-.358.195-.67.313-.7.263s.24-.246.6-.441.217-.053.245,0S953.615,670.445,953.257,670.64Z",
    transform: "translate(-815.083 -574.004)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M903.8,659.91s-.886,1.158.408,2.9,2.36,3.222,1.933,4.312c0,0-1.951-3.246-3.544-3.291S902.055,661.858,903.8,659.91Z",
    transform: "translate(-772.4 -565.271)",
    fill: "#64ce81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M903.785,659.91a1.457,1.457,0,0,0-.182.364c-1.55,1.82-2.374,3.52-.884,3.562,1.387.04,3.051,2.521,3.45,3.148a1.163,1.163,0,0,1-.048.143s-1.951-3.246-3.544-3.291S902.037,661.858,903.785,659.91Z",
    transform: "translate(-772.382 -565.271)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M903.94,667.7c0,.408.047.738.1.738s.1-.322.1-.738-.056-.216-.113-.216S903.94,667.288,903.94,667.7Z",
    transform: "translate(-774.296 -571.546)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M899.3,670.64c.358.195.669.313.7.263s-.24-.246-.6-.441-.218-.053-.245,0S898.947,670.445,899.3,670.64Z",
    transform: "translate(-770.099 -574.004)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "M905.69,696.8s2.474-.077,3.222-.607,3.807-1.165,3.992-.322,3.718,4.235.925,4.258-6.49-.435-7.234-.888S905.69,696.8,905.69,696.8Z",
    transform: "translate(-775.764 -595.292)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M913.877,706.793c-2.793.022-6.49-.435-7.234-.888-.567-.345-.794-1.583-.868-2.155h-.084s.161,2,.9,2.448,4.441.91,7.234.888c.805,0,1.084-.293,1.07-.717C914.783,706.629,914.476,706.788,913.877,706.793Z",
    transform: "translate(-775.764 -602.249)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9197",
    "data-name": "Group 9197",
    transform: "translate(287.773 110)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3633",
    "data-name": "Path 3633",
    d: "M841.985,82.173a1.172,1.172,0,0,0-1.908,1.359c.217.331.457.648.685.954,2.751,3.716,4.177,8.228,5.4,12.684a5.969,5.969,0,0,1,.25,3.344,20.844,20.844,0,0,0-.571-8.732,53.278,53.278,0,0,0-3.09-8.257,7.462,7.462,0,0,0-.77-1.352Z",
    transform: "translate(-815.122 -72.256)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3634",
    "data-name": "Path 3634",
    d: "M794.547,104.188c-1.842-.059-2.092,2.759-.243,2.906.486.037.972.048,1.44.063,5.683.155,11.049,2.21,16.224,4.42a7.075,7.075,0,0,1,3.34,2.32,24.418,24.418,0,0,0-8.655-6.132,65.436,65.436,0,0,0-10.209-3.315A8.673,8.673,0,0,0,794.547,104.188Z",
    transform: "translate(-785.5 -86.614)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3635",
    "data-name": "Path 3635",
    d: "M797.233,123c-1.171.041-.906,1.709.273,1.716.309,0,.619,0,.913-.022,3.584-.147,7.256.843,10.817,1.93a5.552,5.552,0,0,1,2.434,1.226,19.487,19.487,0,0,0-6.324-3.245,48.545,48.545,0,0,0-6.88-1.514A6.019,6.019,0,0,0,797.233,123Z",
    transform: "translate(-787.673 -98.535)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3636",
    "data-name": "Path 3636",
    d: "M862.823,181.015c.332,1.127,1.878.457,1.595-.689-.074-.3-.162-.593-.247-.877-1.031-3.436-.983-7.241-.814-10.961a5.57,5.57,0,0,1,.582-2.659,19.5,19.5,0,0,0-1.573,6.928,48.279,48.279,0,0,0,.239,7.046A6.2,6.2,0,0,0,862.823,181.015Z",
    transform: "translate(-829.323 -125.781)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3637",
    "data-name": "Path 3637",
    d: "M803.376,78.713c-.7-.122-.759.906-.055,1.061.184.041.368.074.549.1a20.326,20.326,0,0,1,6.213,2.527,3.418,3.418,0,0,1,1.3,1.042,11.939,11.939,0,0,0-3.366-2.744,30.132,30.132,0,0,0-3.915-1.779,4.1,4.1,0,0,0-.726-.21Z",
    transform: "translate(-791.699 -70.368)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3638",
    "data-name": "Path 3638",
    d: "M773.376,146.648c-1.79.921-.276,3.451,1.562,2.611.482-.221.95-.468,1.4-.7,5.473-2.84,11.826-3.882,18.08-4.688a8.866,8.866,0,0,1,4.589.239,31.132,31.132,0,0,0-11.97-.737,77.653,77.653,0,0,0-11.686,2.516A10.393,10.393,0,0,0,773.376,146.648Z",
    transform: "translate(-772.575 -111.312)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3639",
    "data-name": "Path 3639",
    d: "M787.933,163.427c-1.289,1.2.737,2.619,2.07,1.473.368-.3.689-.622,1.013-.924,3.919-3.683,9.1-6.3,14.26-8.714,1.267-.593,6.479-1.2,7.871-1.164-3.635.324-11.049,1.473-14.364,2.946a79.129,79.129,0,0,0-9.362,5.256A9.918,9.918,0,0,0,787.933,163.427Z",
    transform: "translate(-782.016 -118.302)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3640",
    "data-name": "Path 3640",
    d: "M813.5,184.347c-.368,1.716,2.081,1.742,2.538.026.118-.449.214-.9.306-1.333,1.134-5.256,3.908-10.36,6.78-15.277.707-1.208,4.652-4.67,5.815-5.432-2.807,2.335-8.268,7.488-10.132,10.6a79.618,79.618,0,0,0-4.718,9.646A9.8,9.8,0,0,0,813.5,184.347Z",
    transform: "translate(-798.429 -123.679)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3641",
    "data-name": "Path 3641",
    d: "M859.03,56.882c-.877-1.786-3.381-.317-2.578,1.517.21.479.442.947.667,1.4,2.7,5.458,3.624,11.786,4.32,17.977a8.849,8.849,0,0,1-.306,4.545,31.129,31.129,0,0,0,.891-11.852,78.628,78.628,0,0,0-2.294-11.616A10.255,10.255,0,0,0,859.03,56.882Z",
    transform: "translate(-825.51 -56.072)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3642",
    "data-name": "Path 3642",
    d: "M822.175,63.757a.324.324,0,0,0,.151.044c.1,0,.166-.1.206-.188.217-.475.092-1.1.431-1.473a5.12,5.12,0,0,1,.818,1.37l1.285-.4a1.918,1.918,0,0,1-.243,1.473,2.022,2.022,0,0,1,.6.413.667.667,0,0,1,.158.681,3.263,3.263,0,0,1-.906.088,5.919,5.919,0,0,1-.1,1.691.306.306,0,0,1-.111.214c-.092.063-.217,0-.313-.052a2.994,2.994,0,0,1-1.057-1.1l-.49,1.1a.508.508,0,0,1-.214.284.343.343,0,0,1-.4-.136,1.042,1.042,0,0,1-.14-.435l-.18-1.1a.258.258,0,0,0-.059-.155.276.276,0,0,0-.188-.055h-1.363c-.077-.243.162-.468.394-.567s.508-.18.626-.405c.236-.46-.368-1.1-.118-1.5C821.284,63.1,821.777,63.562,822.175,63.757Z",
    transform: "translate(-802.593 -59.905)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3643",
    "data-name": "Path 3643",
    d: "M885.2,82.173a1.172,1.172,0,0,1,1.908,1.359c-.221.331-.457.648-.685.954-2.751,3.716-4.177,8.228-5.407,12.684a5.935,5.935,0,0,0-.247,3.344,20.843,20.843,0,0,1,.571-8.732,54.622,54.622,0,0,1,3.086-8.246A7.7,7.7,0,0,1,885.2,82.173Z",
    transform: "translate(-840.84 -72.256)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3644",
    "data-name": "Path 3644",
    d: "M906.078,104.188c1.841-.059,2.092,2.759.243,2.906-.482.037-.972.048-1.436.063-5.687.155-11.049,2.21-16.224,4.42a6.969,6.969,0,0,0-3.34,2.32,24.386,24.386,0,0,1,8.655-6.132,65.431,65.431,0,0,1,10.209-3.315A8.674,8.674,0,0,1,906.078,104.188Z",
    transform: "translate(-843.901 -86.614)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3645",
    "data-name": "Path 3645",
    d: "M915.534,122.995c1.175.041.91,1.709-.269,1.716-.309,0-.619,0-.913-.022-3.587-.147-7.255.843-10.817,1.93a5.532,5.532,0,0,0-2.434,1.226,19.485,19.485,0,0,1,6.324-3.245,48.538,48.538,0,0,1,6.9-1.521A6,6,0,0,1,915.534,122.995Z",
    transform: "translate(-853.869 -98.535)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3646",
    "data-name": "Path 3646",
    d: "M920.767,78.713c.7-.122.759.906.055,1.061-.184.041-.368.074-.549.1a20.347,20.347,0,0,0-6.217,2.527,3.407,3.407,0,0,0-1.3,1.042,11.927,11.927,0,0,1,3.363-2.744,30.408,30.408,0,0,1,3.919-1.779,4.1,4.1,0,0,1,.726-.21Z",
    transform: "translate(-861.216 -70.368)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3647",
    "data-name": "Path 3647",
    d: "M882.418,197.039c-.158.7-1.127.368-1-.368.033-.184.077-.368.118-.545a20.358,20.358,0,0,0,.063-6.707,3.388,3.388,0,0,0-.46-1.6,11.9,11.9,0,0,1,1.234,4.158,29.5,29.5,0,0,1,.129,4.3A3.68,3.68,0,0,1,882.418,197.039Z",
    transform: "translate(-841.215 -139.781)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3648",
    "data-name": "Path 3648",
    d: "M914.831,181.327c.552.935-.8.873-1.4-.063-.155-.243-.3-.49-.435-.737a50.465,50.465,0,0,0-6.806-8.408,9.442,9.442,0,0,0-2.11-1.819,33.517,33.517,0,0,1,5.525,4.725c1.65,1.727,3.108,3.528,4.537,5.326A8.69,8.69,0,0,1,914.831,181.327Z",
    transform: "translate(-855.731 -128.592)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3649",
    "data-name": "Path 3649",
    d: "M799.918,181.327c-.552.935.8.873,1.4-.063.158-.243.3-.49.438-.737a50.462,50.462,0,0,1,6.806-8.408,9.364,9.364,0,0,1,2.11-1.819,33.366,33.366,0,0,0-5.524,4.725c-1.65,1.727-3.112,3.528-4.537,5.326A8.7,8.7,0,0,0,799.918,181.327Z",
    transform: "translate(-789.765 -128.592)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3650",
    "data-name": "Path 3650",
    d: "M848.669,197.039c.158.7,1.127.368,1-.368-.033-.184-.077-.368-.118-.545a20.355,20.355,0,0,1-.063-6.707,3.39,3.39,0,0,1,.46-1.6,11.9,11.9,0,0,0-1.215,4.169,29.483,29.483,0,0,0-.129,4.3,3.676,3.676,0,0,0,.066.748Z",
    transform: "translate(-820.627 -139.781)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3651",
    "data-name": "Path 3651",
    d: "M905.427,97.762c.7-.125.759.9.055,1.061-.184.041-.368.07-.549.1a20.391,20.391,0,0,0-6.217,2.53,3.389,3.389,0,0,0-1.3,1.039,11.864,11.864,0,0,1,3.366-2.74,29.176,29.176,0,0,1,3.915-1.779A3.556,3.556,0,0,1,905.427,97.762Z",
    transform: "translate(-851.517 -82.519)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3652",
    "data-name": "Path 3652",
    d: "M891.567,60.234c.608-.368,1.042.556.446.965-.155.107-.317.2-.468.3a20.246,20.246,0,0,0-4.821,4.67,3.315,3.315,0,0,0-.814,1.447,11.9,11.9,0,0,1,2.1-3.8,29.646,29.646,0,0,1,2.969-3.112,3.849,3.849,0,0,1,.593-.468Z",
    transform: "translate(-844.236 -58.648)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3653",
    "data-name": "Path 3653",
    d: "M920.12,146.648c1.79.921.276,3.451-1.562,2.611-.482-.221-.954-.468-1.4-.7-5.473-2.84-11.83-3.882-18.08-4.688a8.866,8.866,0,0,0-4.589.239,31.127,31.127,0,0,1,11.97-.737,77.652,77.652,0,0,1,11.686,2.516A10.484,10.484,0,0,1,920.12,146.648Z",
    transform: "translate(-849.694 -111.312)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3654",
    "data-name": "Path 3654",
    d: "M906.944,163.427c1.285,1.2-.737,2.619-2.074,1.473-.35-.3-.689-.622-1.009-.924-3.922-3.683-9.1-6.3-14.261-8.714-1.267-.593-6.482-1.2-7.871-1.164,3.635.324,11.049,1.473,14.364,2.946a79.191,79.191,0,0,1,9.366,5.256A9.929,9.929,0,0,1,906.944,163.427Z",
    transform: "translate(-841.633 -118.302)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3655",
    "data-name": "Path 3655",
    d: "M887.453,186.654c.158,1.749-2.287,1.473-2.523-.291-.063-.46-.1-.921-.136-1.363-.468-5.355-2.578-10.765-4.814-16.006-.549-1.285-4.029-5.211-5.09-6.114,2.493,2.667,7.267,8.471,8.725,11.786a79.307,79.307,0,0,1,3.469,10.158,10.133,10.133,0,0,1,.368,1.83Z",
    transform: "translate(-837.275 -124.027)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3656",
    "data-name": "Path 3656",
    d: "M907.09,63.757a.323.323,0,0,1-.151.044c-.1,0-.166-.1-.206-.188-.221-.475-.092-1.1-.431-1.473a5.12,5.12,0,0,0-.818,1.37l-1.285-.4a1.9,1.9,0,0,0,.243,1.473,2.04,2.04,0,0,0-.608.412.67.67,0,0,0-.155.681,3.251,3.251,0,0,0,.906.088,6.063,6.063,0,0,0,.1,1.691.32.32,0,0,0,.111.214c.1.063.221,0,.317-.052a3,3,0,0,0,1.057-1.1l.479,1.142a.494.494,0,0,0,.214.284.335.335,0,0,0,.4-.136,1,1,0,0,0,.144-.435l.177-1.1a.287.287,0,0,1,.063-.155.276.276,0,0,1,.188-.055h1.363c.077-.243-.166-.468-.4-.567s-.5-.18-.622-.405c-.236-.46.368-1.1.114-1.5C907.985,63.1,907.492,63.562,907.09,63.757Z",
    transform: "translate(-855.449 -59.905)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3657",
    "data-name": "Path 3657",
    d: "M917.631,207.505a.325.325,0,0,1-.151.044c-.1,0-.166-.1-.206-.184-.217-.479-.092-1.1-.431-1.5a5.178,5.178,0,0,0-.818,1.37l-1.285-.4a1.919,1.919,0,0,0,.243,1.473,2.022,2.022,0,0,0-.6.412.667.667,0,0,0-.158.681,3.267,3.267,0,0,0,.906.092,5.9,5.9,0,0,0,.1,1.687.313.313,0,0,0,.11.217c.092.059.217,0,.313-.055a2.994,2.994,0,0,0,1.057-1.1l.479,1.142a.53.53,0,0,0,.214.287.368.368,0,0,0,.4-.14,1.04,1.04,0,0,0,.14-.435l.18-1.086a.2.2,0,0,1,.247-.206c.453,0,.91-.018,1.363,0,.077-.243-.162-.464-.394-.567s-.508-.177-.626-.405c-.236-.457.368-1.1.118-1.492C918.537,206.85,918.029,207.31,917.631,207.505Z",
    transform: "translate(-862.114 -151.184)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3658",
    "data-name": "Path 3658",
    d: "M947.219,111.125a.291.291,0,0,1-.155.044c-.1,0-.162-.1-.2-.184-.221-.475-.1-1.1-.431-1.5a5.156,5.156,0,0,0-.818,1.374l-1.285-.4a1.9,1.9,0,0,0,.243,1.473,1.993,1.993,0,0,0-.608.412.685.685,0,0,0-.158.681,3.292,3.292,0,0,0,.91.092,6.028,6.028,0,0,0,.1,1.687.328.328,0,0,0,.11.217c.1.059.217,0,.313-.052a3.013,3.013,0,0,0,1.061-1.1l.475,1.142a.516.516,0,0,0,.214.287.346.346,0,0,0,.4-.14.979.979,0,0,0,.144-.435l.177-1.1a.292.292,0,0,1,.059-.151.269.269,0,0,1,.192-.055h1.359c.081-.239-.162-.464-.394-.567s-.508-.177-.622-.4c-.236-.46.368-1.1.114-1.5C948.11,110.47,947.613,110.93,947.219,111.125Z",
    transform: "translate(-880.826 -89.97)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3659",
    "data-name": "Path 3659",
    d: "M826.606,220.826a.435.435,0,0,1-.21.063c-.136,0-.232-.136-.287-.261-.306-.659-.129-1.521-.6-2.077a7.159,7.159,0,0,0-1.138,1.908l-1.794-.552a2.677,2.677,0,0,0,.339,2.051,2.722,2.722,0,0,0-.843.575.939.939,0,0,0-.221.947,4.6,4.6,0,0,0,1.267.129,8.28,8.28,0,0,0,.136,2.353.442.442,0,0,0,.151.3.424.424,0,0,0,.438-.074,4.136,4.136,0,0,0,1.473-1.562l.667,1.591a.7.7,0,0,0,.3.4.479.479,0,0,0,.56-.192,1.424,1.424,0,0,0,.2-.6l.251-1.514a.368.368,0,0,1,.081-.217.387.387,0,0,1,.265-.074c.633,0,1.267-.026,1.9,0,.11-.339-.228-.648-.549-.792s-.707-.247-.869-.56c-.331-.641.523-1.532.158-2.085C827.847,219.913,827.158,220.557,826.606,220.826Z",
    transform: "translate(-803.703 -159.193)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3660",
    "data-name": "Path 3660",
    d: "M777.393,112.9a.45.45,0,0,1-.214.063c-.133,0-.228-.136-.287-.261-.3-.663-.129-1.521-.6-2.081a7.2,7.2,0,0,0-1.142,1.911l-1.79-.556a2.655,2.655,0,0,0,.339,2.055,2.678,2.678,0,0,0-.843.575.928.928,0,0,0-.221.947,4.575,4.575,0,0,0,1.267.125,8.4,8.4,0,0,0,.133,2.353.431.431,0,0,0,.155.3c.133.085.3,0,.438-.074A4.166,4.166,0,0,0,776.1,116.7l.667,1.591a.737.737,0,0,0,.295.4.479.479,0,0,0,.56-.192,1.43,1.43,0,0,0,.2-.6l.247-1.517a.4.4,0,0,1,.085-.214.368.368,0,0,1,.265-.074c.63,0,1.263-.026,1.9-.022.107-.335-.228-.648-.552-.788s-.707-.25-.869-.563c-.328-.641.523-1.528.162-2.081C778.634,111.986,777.946,112.624,777.393,112.9Z",
    transform: "translate(-772.585 -90.693)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3661",
    "data-name": "Path 3661",
    d: "M930.63,181.568a.2.2,0,0,1-.111.033c-.074,0-.121-.074-.155-.136-.162-.368-.066-.81-.317-1.1a3.713,3.713,0,0,0-.6,1.013l-.954-.295a1.4,1.4,0,0,0,.181,1.1,1.518,1.518,0,0,0-.449.306.5.5,0,0,0-.114.5,2.579,2.579,0,0,0,.67.066,4.3,4.3,0,0,0,.074,1.249.232.232,0,0,0,.081.162c.07.044.162,0,.232-.041a2.21,2.21,0,0,0,.781-.829l.368.843a.394.394,0,0,0,.158.214.258.258,0,0,0,.3-.1.738.738,0,0,0,.1-.32l.133-.807a.147.147,0,0,1,.184-.151H932.2c.059-.18-.122-.346-.291-.42a.887.887,0,0,1-.464-.3c-.173-.343.28-.814.085-1.1S930.91,181.424,930.63,181.568Z",
    transform: "translate(-870.914 -134.933)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3662",
    "data-name": "Path 3662",
    d: "M863.734,220.162a.217.217,0,0,1-.114.033c-.07,0-.122-.074-.151-.14-.162-.35-.07-.807-.317-1.1a3.8,3.8,0,0,0-.608,1.017l-.95-.295a1.4,1.4,0,0,0,.18,1.1,1.451,1.451,0,0,0-.449.306.5.5,0,0,0-.118.5,2.577,2.577,0,0,0,.674.066,4.422,4.422,0,0,0,.07,1.249.228.228,0,0,0,.081.158c.07.048.162,0,.232-.037a2.21,2.21,0,0,0,.785-.829l.368.843a.393.393,0,0,0,.158.214.258.258,0,0,0,.3-.1.739.739,0,0,0,.1-.32l.133-.807a.206.206,0,0,1,.044-.114.232.232,0,0,1,.14-.04H865.3c.055-.18-.122-.346-.295-.42a.849.849,0,0,1-.46-.3c-.177-.343.276-.814.085-1.1S864.028,220.014,863.734,220.162Z",
    transform: "translate(-828.599 -159.446)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3663",
    "data-name": "Path 3663",
    d: "M799.035,85.068a.214.214,0,0,1-.11.033.2.2,0,0,1-.155-.136c-.162-.368-.07-.81-.317-1.1a3.781,3.781,0,0,0-.608,1.013l-.95-.295a1.415,1.415,0,0,0,.18,1.1,1.439,1.439,0,0,0-.449.3.5.5,0,0,0-.118.5,2.317,2.317,0,0,0,.674.066,4.469,4.469,0,0,0,.07,1.252.232.232,0,0,0,.085.158c.07.044.158,0,.232-.037a2.209,2.209,0,0,0,.781-.832l.368.847a.369.369,0,0,0,.158.21.258.258,0,0,0,.3-.1.738.738,0,0,0,.1-.32l.133-.8a.206.206,0,0,1,.044-.114.192.192,0,0,1,.14-.041H800.6c.055-.177-.122-.343-.295-.42s-.368-.133-.46-.3c-.177-.339.28-.814.085-1.1S799.329,84.924,799.035,85.068Z",
    transform: "translate(-787.678 -73.704)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3664",
    "data-name": "Path 3664",
    d: "M833.47,161.2a.2.2,0,0,1-.11.033c-.074,0-.122-.07-.151-.136-.162-.368-.07-.81-.32-1.1a3.864,3.864,0,0,0-.6,1.013l-.954-.295a1.432,1.432,0,0,0,.181,1.1,1.473,1.473,0,0,0-.446.306.5.5,0,0,0-.118.5,2.424,2.424,0,0,0,.67.066,4.467,4.467,0,0,0,.074,1.252.228.228,0,0,0,.081.158c.07.044.162,0,.232-.041a2.21,2.21,0,0,0,.784-.829l.368.843a.368.368,0,0,0,.158.214.251.251,0,0,0,.295-.1.738.738,0,0,0,.107-.32l.133-.8a.176.176,0,0,1,.048-.122.181.181,0,0,1,.14-.041h1.005c.059-.177-.118-.346-.291-.42a.849.849,0,0,1-.46-.3c-.177-.339.276-.814.085-1.1S833.765,161.054,833.47,161.2Z",
    transform: "translate(-809.466 -122.008)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3665",
    "data-name": "Path 3665",
    d: "M808.48,131.522a.275.275,0,0,1-.11.033.206.206,0,0,1-.151-.14c-.162-.35-.07-.807-.32-1.1a3.785,3.785,0,0,0-.6,1.017l-.954-.295a1.44,1.44,0,0,0,.18,1.1,1.441,1.441,0,0,0-.449.3.5.5,0,0,0-.114.5,2.28,2.28,0,0,0,.67.066,4.462,4.462,0,0,0,.074,1.252.229.229,0,0,0,.081.158c.07.044.162,0,.232-.037a2.239,2.239,0,0,0,.784-.832l.368.847a.368.368,0,0,0,.155.21.258.258,0,0,0,.3-.1.737.737,0,0,0,.107-.32l.129-.8a.206.206,0,0,1,.044-.114.2.2,0,0,1,.144-.041h1.005c.059-.177-.122-.343-.291-.42s-.368-.133-.464-.3c-.173-.339.28-.814.088-1.1S808.775,131.374,808.48,131.522Z",
    transform: "translate(-793.666 -103.176)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3666",
    "data-name": "Path 3666",
    d: "M915.82,138.508a.2.2,0,0,1-.11.033c-.074,0-.122-.07-.151-.136-.162-.368-.07-.81-.32-1.1a3.766,3.766,0,0,0-.6,1.013l-.954-.295a1.433,1.433,0,0,0,.181,1.1,1.517,1.517,0,0,0-.449.306.5.5,0,0,0-.114.5,2.413,2.413,0,0,0,.67.066,4.469,4.469,0,0,0,.074,1.252.229.229,0,0,0,.081.158c.07.044.162,0,.232-.04a2.21,2.21,0,0,0,.785-.829l.368.843a.368.368,0,0,0,.158.214.254.254,0,0,0,.295-.1.735.735,0,0,0,.107-.32l.133-.8a.147.147,0,0,1,.184-.155h1.005c.059-.177-.122-.346-.291-.42a.887.887,0,0,1-.464-.3c-.173-.339.28-.814.088-1.1S916.118,138.364,915.82,138.508Z",
    transform: "translate(-861.534 -107.611)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3667",
    "data-name": "Path 3667",
    d: "M863.734,132.668a.218.218,0,0,1-.114.033c-.07,0-.121-.07-.151-.136-.162-.368-.07-.81-.317-1.1a3.776,3.776,0,0,0-.608,1.013l-.95-.295a1.414,1.414,0,0,0,.18,1.1,1.441,1.441,0,0,0-.449.3.5.5,0,0,0-.118.5,2.306,2.306,0,0,0,.674.066,4.466,4.466,0,0,0,.07,1.252.247.247,0,0,0,.081.158c.07.044.162,0,.232-.037a2.21,2.21,0,0,0,.785-.832l.368.847a.368.368,0,0,0,.158.21.258.258,0,0,0,.3-.1.739.739,0,0,0,.1-.32l.132-.8a.207.207,0,0,1,.044-.114.192.192,0,0,1,.14-.041H865.3c.055-.177-.121-.343-.295-.42s-.368-.133-.46-.3c-.177-.339.276-.814.085-1.1S864.029,132.524,863.734,132.668Z",
    transform: "translate(-828.6 -103.906)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3668",
    "data-name": "Path 3668",
    d: "M847.39,139.782a.276.276,0,0,1-.11.033.206.206,0,0,1-.151-.14c-.162-.368-.07-.807-.32-1.1a3.735,3.735,0,0,0-.6,1.017l-.954-.3a1.444,1.444,0,0,0,.18,1.1,1.44,1.44,0,0,0-.449.3.5.5,0,0,0-.114.5,2.282,2.282,0,0,0,.67.066,4.462,4.462,0,0,0,.074,1.252.229.229,0,0,0,.081.158c.07.044.162,0,.232-.037a2.24,2.24,0,0,0,.785-.832l.368.847a.368.368,0,0,0,.158.21.254.254,0,0,0,.295-.1.737.737,0,0,0,.107-.32l.133-.8a.2.2,0,0,1,.041-.114.2.2,0,0,1,.144-.041h1.005c.059-.177-.122-.342-.291-.42s-.368-.133-.464-.3c-.173-.339.28-.814.088-1.1S847.685,139.634,847.39,139.782Z",
    transform: "translate(-818.268 -108.417)",
    fill: "#397a4b",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3669",
    "data-name": "Path 3669",
    d: "M832.154,96.748a.217.217,0,0,1-.114.033c-.07,0-.122-.07-.151-.136-.162-.368-.07-.81-.317-1.1a3.783,3.783,0,0,0-.608,1.013l-.95-.295a1.4,1.4,0,0,0,.181,1.1,1.517,1.517,0,0,0-.449.306.5.5,0,0,0-.118.5,2.453,2.453,0,0,0,.674.066,4.471,4.471,0,0,0,.07,1.252.247.247,0,0,0,.081.158c.07.044.162,0,.232-.041a2.173,2.173,0,0,0,.784-.829l.368.843a.394.394,0,0,0,.158.214.258.258,0,0,0,.3-.1.736.736,0,0,0,.1-.32l.133-.8a.2.2,0,0,1,.044-.114.192.192,0,0,1,.14-.041h1.009c.055-.18-.122-.346-.295-.42a.849.849,0,0,1-.46-.3c-.177-.343.276-.814.085-1.1S832.448,96.6,832.154,96.748Z",
    transform: "translate(-808.632 -81.115)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3670",
    "data-name": "Path 3670",
    d: "M862.164,152.922a.312.312,0,0,1-.114.033c-.07,0-.121-.074-.151-.14-.162-.35-.07-.807-.317-1.1a3.8,3.8,0,0,0-.608,1.016l-.95-.295a1.408,1.408,0,0,0,.18,1.1,1.439,1.439,0,0,0-.449.3.5.5,0,0,0-.118.5,2.318,2.318,0,0,0,.674.066,4.471,4.471,0,0,0,.07,1.252.247.247,0,0,0,.081.158c.07.044.162,0,.236-.037a2.228,2.228,0,0,0,.781-.832l.368.847a.368.368,0,0,0,.158.21.258.258,0,0,0,.3-.1.738.738,0,0,0,.1-.32l.133-.8a.206.206,0,0,1,.044-.114.192.192,0,0,1,.14-.04h1.009c.055-.177-.121-.343-.295-.42s-.368-.133-.46-.3c-.177-.339.276-.814.085-1.1S862.459,152.767,862.164,152.922Z",
    transform: "translate(-827.607 -116.755)",
    fill: "#397a4b",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9202",
    "data-name": "Group 9202",
    transform: "translate(70 174.381)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3633-2",
    "data-name": "Path 3633",
    d: "M841.505,82.064a.907.907,0,0,0-1.476,1.052c.168.257.353.5.53.738,2.129,2.876,3.232,6.367,4.181,9.815a4.618,4.618,0,0,1,.194,2.588,16.129,16.129,0,0,0-.442-6.757,41.218,41.218,0,0,0-2.391-6.39,5.77,5.77,0,0,0-.6-1.046Z",
    transform: "translate(-820.826 -74.39)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3634-2",
    "data-name": "Path 3634",
    d: "M794.205,104.188a1.13,1.13,0,0,0-.188,2.249c.376.029.752.037,1.114.048,4.4.12,8.55,1.71,12.554,3.42a5.475,5.475,0,0,1,2.585,1.8,18.9,18.9,0,0,0-6.7-4.745,50.632,50.632,0,0,0-7.9-2.565A6.712,6.712,0,0,0,794.205,104.188Z",
    transform: "translate(-787.204 -90.55)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3635-2",
    "data-name": "Path 3635",
    d: "M797.062,123c-.906.031-.7,1.322.211,1.328.239,0,.479,0,.707-.017a25.729,25.729,0,0,1,8.37,1.493,4.3,4.3,0,0,1,1.884.949,15.078,15.078,0,0,0-4.893-2.511,37.563,37.563,0,0,0-5.324-1.171A4.658,4.658,0,0,0,797.062,123Z",
    transform: "translate(-789.665 -104.018)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3636-2",
    "data-name": "Path 3636",
    d: "M862.712,177.58c.256.872,1.453.353,1.234-.533-.057-.231-.125-.459-.191-.678a25.745,25.745,0,0,1-.63-8.481,4.311,4.311,0,0,1,.45-2.058,15.086,15.086,0,0,0-1.217,5.361,37.346,37.346,0,0,0,.185,5.452A4.794,4.794,0,0,0,862.712,177.58Z",
    transform: "translate(-836.922 -134.741)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3637-2",
    "data-name": "Path 3637",
    d: "M803.251,78.711c-.544-.094-.587.7-.043.821.142.031.285.057.425.08a15.729,15.729,0,0,1,4.808,1.955,2.646,2.646,0,0,1,1.006.807,9.239,9.239,0,0,0-2.6-2.123,23.319,23.319,0,0,0-3.029-1.377,3.172,3.172,0,0,0-.561-.162Z",
    transform: "translate(-794.264 -72.253)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3638-2",
    "data-name": "Path 3638",
    d: "M773.195,145.85c-1.385.712-.214,2.67,1.208,2.021.373-.171.735-.362,1.083-.542,4.235-2.2,9.151-3,13.99-3.628a6.861,6.861,0,0,1,3.551.185,24.089,24.089,0,0,0-9.262-.57,60.086,60.086,0,0,0-9.043,1.947A8.046,8.046,0,0,0,773.195,145.85Z",
    transform: "translate(-772.575 -118.44)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3639-2",
    "data-name": "Path 3639",
    d: "M787.84,161.316c-1,.929.57,2.026,1.6,1.14.285-.234.533-.482.784-.715,3.032-2.85,7.042-4.873,11.035-6.743a25.694,25.694,0,0,1,6.09-.9c-2.813.251-8.55,1.14-11.115,2.28a61.241,61.241,0,0,0-7.245,4.067A7.684,7.684,0,0,0,787.84,161.316Z",
    transform: "translate(-783.261 -126.317)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3640-2",
    "data-name": "Path 3640",
    d: "M813.487,179.367c-.285,1.328,1.61,1.348,1.964.02.091-.348.165-.7.237-1.032.878-4.067,3.024-8.017,5.247-11.822a25.723,25.723,0,0,1,4.5-4.2c-2.172,1.807-6.4,5.794-7.84,8.2A61.619,61.619,0,0,0,813.943,178a7.59,7.59,0,0,0-.456,1.371Z",
    transform: "translate(-801.903 -132.294)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3641-2",
    "data-name": "Path 3641",
    d: "M858.411,56.7c-.678-1.382-2.616-.245-1.995,1.174.162.37.342.732.516,1.08,2.086,4.224,2.8,9.12,3.343,13.911a6.847,6.847,0,0,1-.237,3.517,24.089,24.089,0,0,0,.69-9.171,60.838,60.838,0,0,0-1.775-8.989A7.941,7.941,0,0,0,858.411,56.7Z",
    transform: "translate(-832.604 -56.072)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3642-2",
    "data-name": "Path 3642",
    d: "M821.694,63.391a.251.251,0,0,0,.117.034c.074,0,.128-.077.16-.145.168-.368.071-.855.333-1.14a3.963,3.963,0,0,1,.633,1.06l.995-.308a1.485,1.485,0,0,1-.188,1.14,1.564,1.564,0,0,1,.467.319.516.516,0,0,1,.123.527,2.525,2.525,0,0,1-.7.068,4.586,4.586,0,0,1-.077,1.308.237.237,0,0,1-.086.165c-.071.048-.168,0-.242-.04a2.317,2.317,0,0,1-.818-.855l-.379.849a.393.393,0,0,1-.165.219.265.265,0,0,1-.311-.105.805.805,0,0,1-.108-.336l-.14-.855a.2.2,0,0,0-.046-.12.214.214,0,0,0-.145-.043h-1.055c-.06-.188.125-.362.3-.439s.393-.14.484-.313c.182-.356-.285-.855-.091-1.157C821,62.884,821.386,63.24,821.694,63.391Z",
    transform: "translate(-806.615 -60.411)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3643-2",
    "data-name": "Path 3643",
    d: "M884.149,82.064a.907.907,0,0,1,1.476,1.052c-.171.257-.353.5-.53.738-2.129,2.876-3.232,6.367-4.184,9.815a4.593,4.593,0,0,0-.191,2.588,16.13,16.13,0,0,1,.442-6.757,42.283,42.283,0,0,1,2.388-6.381A5.956,5.956,0,0,1,884.149,82.064Z",
    transform: "translate(-849.99 -74.39)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3644-2",
    "data-name": "Path 3644",
    d: "M901.382,104.188a1.13,1.13,0,0,1,.188,2.249c-.373.029-.752.037-1.111.048-4.4.12-8.55,1.71-12.554,3.42a5.393,5.393,0,0,0-2.585,1.8,18.872,18.872,0,0,1,6.7-4.745,50.637,50.637,0,0,1,7.9-2.565A6.712,6.712,0,0,1,901.382,104.188Z",
    transform: "translate(-853.547 -90.55)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3645-2",
    "data-name": "Path 3645",
    d: "M912.269,122.994c.909.031.7,1.322-.208,1.328-.239,0-.479,0-.707-.017a25.715,25.715,0,0,0-8.37,1.493,4.281,4.281,0,0,0-1.884.949,15.079,15.079,0,0,1,4.893-2.511,37.563,37.563,0,0,1,5.338-1.177A4.643,4.643,0,0,1,912.269,122.994Z",
    transform: "translate(-864.83 -104.017)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3646-2",
    "data-name": "Path 3646",
    d: "M918.956,78.711c.544-.094.587.7.043.821-.142.031-.285.057-.425.08a15.743,15.743,0,0,0-4.811,1.955,2.635,2.635,0,0,0-1,.807,9.227,9.227,0,0,1,2.6-2.123,23.533,23.533,0,0,1,3.032-1.377,3.175,3.175,0,0,1,.562-.162Z",
    transform: "translate(-873.103 -72.253)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3647-2",
    "data-name": "Path 3647",
    d: "M882.129,194.953c-.123.541-.872.285-.772-.285.026-.143.06-.285.091-.422a15.754,15.754,0,0,0,.049-5.19,2.622,2.622,0,0,0-.356-1.237,9.209,9.209,0,0,1,.955,3.218,22.825,22.825,0,0,1,.1,3.329A2.848,2.848,0,0,1,882.129,194.953Z",
    transform: "translate(-850.405 -150.52)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3648-2",
    "data-name": "Path 3648",
    d: "M912.4,178.833c.427.724-.621.675-1.083-.048-.12-.188-.231-.379-.336-.57a39.054,39.054,0,0,0-5.267-6.506,7.307,7.307,0,0,0-1.633-1.408,25.931,25.931,0,0,1,4.275,3.657c1.277,1.337,2.405,2.73,3.511,4.121A6.711,6.711,0,0,1,912.4,178.833Z",
    transform: "translate(-866.89 -137.931)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3649-2",
    "data-name": "Path 3649",
    d: "M799.888,178.833c-.427.724.621.675,1.08-.048.123-.188.234-.379.339-.57a39.037,39.037,0,0,1,5.267-6.506,7.243,7.243,0,0,1,1.633-1.408,25.818,25.818,0,0,0-4.275,3.656c-1.277,1.337-2.408,2.73-3.511,4.121A6.735,6.735,0,0,0,799.888,178.833Z",
    transform: "translate(-792.032 -137.931)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3650-2",
    "data-name": "Path 3650",
    d: "M848.648,194.953c.123.542.872.285.772-.285-.026-.142-.06-.285-.091-.422a15.754,15.754,0,0,1-.049-5.19,2.622,2.622,0,0,1,.356-1.237,9.211,9.211,0,0,0-.94,3.226,22.833,22.833,0,0,0-.1,3.329,2.853,2.853,0,0,0,.051.579Z",
    transform: "translate(-827.06 -150.52)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3651-2",
    "data-name": "Path 3651",
    d: "M903.616,97.76c.544-.1.587.7.043.821-.143.031-.285.054-.425.077a15.779,15.779,0,0,0-4.811,1.958,2.622,2.622,0,0,0-1,.8,9.181,9.181,0,0,1,2.6-2.12,22.569,22.569,0,0,1,3.029-1.377A2.751,2.751,0,0,1,903.616,97.76Z",
    transform: "translate(-862.103 -85.933)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3652-2",
    "data-name": "Path 3652",
    d: "M890.288,60.215c.47-.285.807.43.345.747-.12.083-.245.157-.362.231a15.666,15.666,0,0,0-3.731,3.614,2.564,2.564,0,0,0-.63,1.12,9.206,9.206,0,0,1,1.622-2.941,22.936,22.936,0,0,1,2.3-2.408A2.984,2.984,0,0,1,890.288,60.215Z",
    transform: "translate(-853.841 -58.988)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3653-2",
    "data-name": "Path 3653",
    d: "M914.323,145.85c1.385.712.214,2.67-1.208,2.021-.373-.171-.738-.362-1.083-.542-4.235-2.2-9.154-3-13.99-3.628a6.861,6.861,0,0,0-3.551.185,24.087,24.087,0,0,1,9.262-.57,60.091,60.091,0,0,1,9.043,1.947A8.119,8.119,0,0,1,914.323,145.85Z",
    transform: "translate(-860.104 -118.44)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3654-2",
    "data-name": "Path 3654",
    d: "M901.241,161.316c.995.929-.57,2.026-1.6,1.14-.271-.234-.533-.482-.781-.715-3.035-2.85-7.045-4.873-11.035-6.743a25.717,25.717,0,0,0-6.09-.9c2.813.251,8.55,1.14,11.115,2.28a61.274,61.274,0,0,1,7.247,4.067A7.676,7.676,0,0,1,901.241,161.316Z",
    transform: "translate(-850.98 -126.317)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3655-2",
    "data-name": "Path 3655",
    d: "M884.611,181.276c.122,1.354-1.77,1.14-1.952-.225-.048-.356-.077-.712-.105-1.054-.362-4.144-1.995-8.33-3.725-12.386a25.656,25.656,0,0,0-3.939-4.731c1.93,2.063,5.623,6.555,6.752,9.12a61.385,61.385,0,0,1,2.685,7.86,7.838,7.838,0,0,1,.285,1.416Z",
    transform: "translate(-845.961 -132.687)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3656-2",
    "data-name": "Path 3656",
    d: "M906.311,63.391a.251.251,0,0,1-.117.034c-.077,0-.128-.077-.16-.145-.171-.368-.071-.855-.333-1.14a3.958,3.958,0,0,0-.633,1.06l-.995-.308a1.473,1.473,0,0,0,.188,1.14,1.579,1.579,0,0,0-.47.319.519.519,0,0,0-.12.527,2.517,2.517,0,0,0,.7.068,4.689,4.689,0,0,0,.074,1.308.248.248,0,0,0,.085.165c.074.048.171,0,.245-.04a2.316,2.316,0,0,0,.818-.855l.371.883a.381.381,0,0,0,.165.219.259.259,0,0,0,.308-.105.774.774,0,0,0,.111-.336l.137-.855a.222.222,0,0,1,.048-.12.214.214,0,0,1,.145-.043h1.054c.06-.188-.128-.362-.308-.439s-.39-.14-.482-.313c-.182-.356.285-.855.088-1.157C907,62.884,906.622,63.24,906.311,63.391Z",
    transform: "translate(-866.554 -60.411)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3657-2",
    "data-name": "Path 3657",
    d: "M916.852,207.135a.251.251,0,0,1-.117.034c-.077,0-.128-.074-.16-.143-.168-.37-.071-.855-.333-1.157a4.008,4.008,0,0,0-.633,1.06l-.995-.308a1.485,1.485,0,0,0,.188,1.14,1.566,1.566,0,0,0-.467.319.516.516,0,0,0-.123.527,2.529,2.529,0,0,0,.7.071,4.559,4.559,0,0,0,.077,1.305.242.242,0,0,0,.086.168c.071.046.168,0,.242-.043a2.317,2.317,0,0,0,.818-.855l.371.883a.41.41,0,0,0,.165.222.285.285,0,0,0,.311-.108.806.806,0,0,0,.108-.336l.14-.841a.154.154,0,0,1,.191-.16c.351,0,.7-.014,1.055,0,.06-.188-.125-.359-.3-.439s-.393-.137-.485-.313c-.182-.353.285-.855.091-1.154C917.553,206.628,917.16,206.984,916.852,207.135Z",
    transform: "translate(-874.112 -163.426)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3658-2",
    "data-name": "Path 3658",
    d: "M946.44,110.755a.226.226,0,0,1-.12.034c-.074,0-.125-.074-.157-.143-.171-.368-.074-.855-.333-1.157a3.993,3.993,0,0,0-.633,1.063l-.995-.311a1.47,1.47,0,0,0,.188,1.14,1.542,1.542,0,0,0-.47.319.531.531,0,0,0-.123.527,2.548,2.548,0,0,0,.7.071,4.664,4.664,0,0,0,.074,1.305.253.253,0,0,0,.085.168c.074.046.168,0,.242-.04a2.332,2.332,0,0,0,.821-.855l.368.883a.4.4,0,0,0,.165.222.268.268,0,0,0,.311-.108.756.756,0,0,0,.111-.336l.137-.855a.226.226,0,0,1,.046-.117.208.208,0,0,1,.148-.043h1.052c.063-.185-.125-.359-.3-.439s-.393-.137-.482-.311c-.182-.356.285-.855.088-1.157C947.129,110.248,946.745,110.6,946.44,110.755Z",
    transform: "translate(-895.341 -94.345)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3659-2",
    "data-name": "Path 3659",
    d: "M825.52,220.311a.336.336,0,0,1-.162.048c-.105,0-.18-.105-.222-.2-.237-.51-.1-1.177-.465-1.607a5.538,5.538,0,0,0-.881,1.476L822.4,219.6a2.071,2.071,0,0,0,.262,1.587,2.106,2.106,0,0,0-.653.445.727.727,0,0,0-.171.732,3.564,3.564,0,0,0,.98.1,6.407,6.407,0,0,0,.105,1.821.342.342,0,0,0,.117.231.328.328,0,0,0,.339-.057,3.2,3.2,0,0,0,1.14-1.208l.516,1.231a.541.541,0,0,0,.231.308.37.37,0,0,0,.433-.148,1.1,1.1,0,0,0,.151-.467l.194-1.171a.286.286,0,0,1,.063-.168.3.3,0,0,1,.205-.057c.49,0,.98-.02,1.468,0,.085-.262-.177-.5-.425-.613s-.547-.191-.673-.433c-.256-.5.4-1.186.123-1.613C826.48,219.6,825.947,220.1,825.52,220.311Z",
    transform: "translate(-807.877 -172.492)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3660-2",
    "data-name": "Path 3660",
    d: "M776.307,112.384a.347.347,0,0,1-.165.048c-.1,0-.177-.105-.222-.2-.234-.513-.1-1.177-.462-1.61a5.562,5.562,0,0,0-.883,1.479l-1.385-.43a2.055,2.055,0,0,0,.262,1.59,2.073,2.073,0,0,0-.653.445.718.718,0,0,0-.171.732,3.539,3.539,0,0,0,.98.1,6.5,6.5,0,0,0,.1,1.821.333.333,0,0,0,.12.234c.1.066.234,0,.339-.057a3.223,3.223,0,0,0,1.14-1.208l.516,1.231a.57.57,0,0,0,.228.308.37.37,0,0,0,.433-.148,1.106,1.106,0,0,0,.154-.467l.191-1.174a.3.3,0,0,1,.065-.165.285.285,0,0,1,.205-.057c.487,0,.978-.02,1.468-.017.083-.259-.177-.5-.427-.61s-.547-.194-.673-.436c-.254-.5.4-1.183.125-1.61C777.267,111.677,776.734,112.17,776.307,112.384Z",
    transform: "translate(-772.586 -95.157)",
    fill: "#397a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3661-2",
    "data-name": "Path 3661",
    d: "M930.054,181.295a.157.157,0,0,1-.086.026c-.057,0-.094-.057-.12-.105-.125-.285-.051-.627-.245-.855a2.876,2.876,0,0,0-.467.784l-.738-.228a1.083,1.083,0,0,0,.14.855,1.174,1.174,0,0,0-.348.237.39.39,0,0,0-.088.39,2,2,0,0,0,.519.051,3.329,3.329,0,0,0,.057.966.179.179,0,0,0,.063.125c.054.034.125,0,.18-.031a1.711,1.711,0,0,0,.6-.641l.285.653a.306.306,0,0,0,.123.165.2.2,0,0,0,.231-.08.572.572,0,0,0,.08-.248l.1-.624a.114.114,0,0,1,.143-.117h.781c.046-.14-.094-.268-.225-.325a.687.687,0,0,1-.359-.231c-.134-.265.217-.63.065-.855S930.271,181.184,930.054,181.295Z",
    transform: "translate(-884.123 -145.116)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3662-2",
    "data-name": "Path 3662",
    d: "M863.156,219.888a.168.168,0,0,1-.088.026c-.054,0-.094-.057-.117-.108-.125-.271-.054-.624-.245-.855a2.943,2.943,0,0,0-.47.787l-.735-.228a1.086,1.086,0,0,0,.14.855,1.12,1.12,0,0,0-.348.237.385.385,0,0,0-.091.39,2,2,0,0,0,.522.051,3.417,3.417,0,0,0,.054.966.176.176,0,0,0,.063.123c.054.037.125,0,.18-.029a1.71,1.71,0,0,0,.607-.641l.285.653a.305.305,0,0,0,.123.165.2.2,0,0,0,.231-.08.571.571,0,0,0,.08-.248l.1-.624a.161.161,0,0,1,.034-.088.179.179,0,0,1,.108-.031h.781c.043-.14-.094-.268-.228-.325a.657.657,0,0,1-.356-.231c-.137-.265.214-.63.066-.855S863.385,219.774,863.156,219.888Z",
    transform: "translate(-836.104 -172.778)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3663-2",
    "data-name": "Path 3663",
    d: "M798.458,84.795a.165.165,0,0,1-.086.026.154.154,0,0,1-.12-.105c-.125-.285-.054-.627-.245-.855a2.923,2.923,0,0,0-.47.784l-.735-.228a1.094,1.094,0,0,0,.14.855,1.114,1.114,0,0,0-.348.234.387.387,0,0,0-.091.39,1.793,1.793,0,0,0,.522.051,3.455,3.455,0,0,0,.054.969.179.179,0,0,0,.066.123c.054.034.123,0,.18-.029a1.709,1.709,0,0,0,.6-.644l.285.655a.285.285,0,0,0,.123.162.2.2,0,0,0,.231-.08.571.571,0,0,0,.08-.248l.1-.621a.159.159,0,0,1,.034-.088.148.148,0,0,1,.108-.031h.781c.043-.137-.094-.265-.228-.325s-.285-.1-.356-.231c-.137-.262.217-.63.066-.855S798.686,84.684,798.458,84.795Z",
    transform: "translate(-789.67 -75.98)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3664-2",
    "data-name": "Path 3664",
    d: "M832.894,160.925a.151.151,0,0,1-.086.026c-.057,0-.094-.054-.117-.105-.125-.285-.054-.627-.248-.855a2.987,2.987,0,0,0-.467.784l-.738-.228a1.109,1.109,0,0,0,.14.855,1.14,1.14,0,0,0-.345.237.385.385,0,0,0-.091.39,1.875,1.875,0,0,0,.519.051,3.46,3.46,0,0,0,.057.969.177.177,0,0,0,.063.123c.054.034.125,0,.18-.031a1.709,1.709,0,0,0,.607-.641l.285.653a.285.285,0,0,0,.123.165.194.194,0,0,0,.228-.08.571.571,0,0,0,.083-.248l.1-.621a.137.137,0,0,1,.037-.094.14.14,0,0,1,.108-.031h.778c.046-.137-.091-.268-.225-.325a.657.657,0,0,1-.356-.231c-.137-.262.214-.63.066-.855S833.122,160.814,832.894,160.925Z",
    transform: "translate(-814.408 -130.523)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3665-2",
    "data-name": "Path 3665",
    d: "M807.9,131.248a.213.213,0,0,1-.085.026.16.16,0,0,1-.117-.108c-.125-.271-.054-.624-.248-.855a2.933,2.933,0,0,0-.467.787l-.738-.228a1.114,1.114,0,0,0,.14.855,1.114,1.114,0,0,0-.348.234.391.391,0,0,0-.088.39,1.765,1.765,0,0,0,.519.051,3.455,3.455,0,0,0,.057.969.177.177,0,0,0,.063.123c.054.034.125,0,.18-.029a1.733,1.733,0,0,0,.607-.644l.285.655a.285.285,0,0,0,.12.162.2.2,0,0,0,.231-.08.568.568,0,0,0,.083-.248l.1-.621a.16.16,0,0,1,.034-.088.151.151,0,0,1,.111-.031h.778c.046-.137-.094-.265-.225-.325s-.285-.1-.359-.231c-.134-.262.217-.63.068-.855S808.132,131.134,807.9,131.248Z",
    transform: "translate(-796.491 -109.259)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3666-2",
    "data-name": "Path 3666",
    d: "M915.244,138.235a.151.151,0,0,1-.085.026c-.057,0-.094-.054-.117-.105-.125-.285-.054-.627-.248-.855a2.918,2.918,0,0,0-.467.784l-.738-.228a1.109,1.109,0,0,0,.14.855,1.174,1.174,0,0,0-.348.237.391.391,0,0,0-.088.39,1.867,1.867,0,0,0,.519.051,3.455,3.455,0,0,0,.057.969.177.177,0,0,0,.063.123c.054.034.125,0,.179-.031a1.709,1.709,0,0,0,.607-.641l.285.653a.285.285,0,0,0,.122.165.2.2,0,0,0,.228-.08.568.568,0,0,0,.083-.248l.1-.621a.114.114,0,0,1,.143-.12h.778c.046-.137-.094-.268-.225-.325a.686.686,0,0,1-.359-.231c-.134-.262.217-.63.068-.855S915.475,138.124,915.244,138.235Z",
    transform: "translate(-873.451 -114.267)",
    fill: "#397a4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3667-2",
    "data-name": "Path 3667",
    d: "M863.157,132.395a.169.169,0,0,1-.088.026c-.054,0-.094-.054-.117-.105-.125-.285-.054-.627-.245-.855a2.925,2.925,0,0,0-.47.784l-.735-.228a1.094,1.094,0,0,0,.14.855,1.116,1.116,0,0,0-.348.234.388.388,0,0,0-.091.39,1.783,1.783,0,0,0,.521.051,3.457,3.457,0,0,0,.054.969.191.191,0,0,0,.063.123c.054.034.125,0,.18-.028a1.709,1.709,0,0,0,.607-.644l.285.656a.285.285,0,0,0,.122.162.2.2,0,0,0,.231-.08.57.57,0,0,0,.08-.248l.1-.621a.16.16,0,0,1,.034-.088.148.148,0,0,1,.108-.031h.781c.043-.137-.094-.265-.228-.325s-.285-.1-.356-.231c-.137-.262.214-.63.065-.855S863.385,132.284,863.157,132.395Z",
    transform: "translate(-836.105 -110.083)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3668-2",
    "data-name": "Path 3668",
    d: "M846.814,139.508a.215.215,0,0,1-.086.026.16.16,0,0,1-.117-.108c-.125-.285-.054-.624-.248-.855a2.887,2.887,0,0,0-.467.787l-.738-.231a1.117,1.117,0,0,0,.14.855,1.113,1.113,0,0,0-.348.234.391.391,0,0,0-.088.39,1.765,1.765,0,0,0,.519.051,3.455,3.455,0,0,0,.057.969.177.177,0,0,0,.063.123c.054.034.125,0,.18-.029a1.732,1.732,0,0,0,.607-.644l.285.656a.285.285,0,0,0,.123.162.2.2,0,0,0,.228-.08.569.569,0,0,0,.083-.248l.1-.621a.156.156,0,0,1,.031-.088.151.151,0,0,1,.111-.031h.778c.046-.137-.094-.265-.225-.325s-.285-.1-.359-.231c-.134-.262.217-.63.068-.855S847.042,139.394,846.814,139.508Z",
    transform: "translate(-824.389 -115.177)",
    fill: "#397a4b",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3669-2",
    "data-name": "Path 3669",
    d: "M831.576,96.475a.168.168,0,0,1-.088.026c-.054,0-.094-.054-.117-.105-.125-.285-.054-.627-.245-.855a2.926,2.926,0,0,0-.47.784l-.735-.228a1.083,1.083,0,0,0,.14.855,1.174,1.174,0,0,0-.348.237.385.385,0,0,0-.091.39,1.9,1.9,0,0,0,.522.051,3.459,3.459,0,0,0,.054.969.191.191,0,0,0,.063.123c.054.034.125,0,.18-.031a1.681,1.681,0,0,0,.607-.641l.285.653a.305.305,0,0,0,.123.165.2.2,0,0,0,.231-.08.569.569,0,0,0,.08-.248l.1-.621a.154.154,0,0,1,.034-.088.148.148,0,0,1,.108-.031h.781c.043-.14-.094-.268-.228-.325a.657.657,0,0,1-.356-.231c-.137-.265.214-.63.066-.855S831.8,96.364,831.576,96.475Z",
    transform: "translate(-813.462 -84.348)",
    fill: "#397a4b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3670-2",
    "data-name": "Path 3670",
    d: "M861.588,152.648a.242.242,0,0,1-.088.026c-.054,0-.094-.057-.117-.108-.125-.271-.054-.624-.245-.855a2.94,2.94,0,0,0-.47.787l-.735-.228a1.088,1.088,0,0,0,.14.855,1.114,1.114,0,0,0-.348.234.388.388,0,0,0-.091.39,1.794,1.794,0,0,0,.522.051,3.455,3.455,0,0,0,.054.969.191.191,0,0,0,.063.123c.054.034.125,0,.182-.028a1.725,1.725,0,0,0,.6-.644l.285.656a.285.285,0,0,0,.122.162.2.2,0,0,0,.231-.08.571.571,0,0,0,.08-.248l.1-.621a.159.159,0,0,1,.034-.088.148.148,0,0,1,.108-.031h.781c.043-.137-.094-.265-.228-.325s-.285-.1-.356-.231c-.137-.262.214-.63.066-.855S861.815,152.528,861.588,152.648Z",
    transform: "translate(-834.979 -124.591)",
    fill: "#397a4b",
    opacity: 0.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrating);
export default __webpack_public_path__ + "static/media/celebrating.f4c9e3c8ef4a69eace6447b4326f93f9.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;